import React, { useEffect, useRef, useState } from "react";
import api from "../lib/api";
import { WIDGETS, DEFAULT_LAYOUT } from "../components/DashWidgets";
import { LayoutGrid, Check, RotateCcw, Plus, X, ArrowLeftRight, ArrowUpDown } from "lucide-react";

const KEY = "mwcrm_dash_layout";
const load = () => { try { const l = JSON.parse(localStorage.getItem(KEY) || "null"); return Array.isArray(l) && l.length ? l.filter((x) => WIDGETS[x.id]) : DEFAULT_LAYOUT; } catch { return DEFAULT_LAYOUT; } };
const today = () => new Date().toISOString().slice(0, 10);
const sumRows = (rows) => ({ adet: rows.length, yekun: rows.reduce((a, r) => a + (r.yekun || 0), 0), kalan: rows.reduce((a, r) => a + (r.kalan || 0), 0) });

export default function Dashboard() {
  const [data, setData] = useState({});
  const [layout, setLayout] = useState(load);
  const [edit, setEdit] = useState(false);
  const dragId = useRef(null);

  useEffect(() => {
    const set = (k) => (v) => setData((d) => ({ ...d, [k]: v }));
    api.get("/reports/overview", { silent: true }).then((r) => set("ov")(r.data)).catch(() => {});
    api.get("/reports/location", { silent: true }).then((r) => set("loc")(r.data)).catch(() => {});
    api.get("/kasa", { silent: true }).then((r) => set("kasa")(r.data.toplam || {})).catch(() => {});
    api.get("/cargo-report", { params: { d1: today(), d2: today() }, silent: true }).then((r) => set("cBugun")(sumRows(r.data.rows || []))).catch(() => {});
    api.get("/cargo-report", { params: { d1: today().slice(0, 8) + "01", d2: today() }, silent: true }).then((r) => set("cAy")(sumRows(r.data.rows || []))).catch(() => {});
  }, []);

  const save = (l) => { setLayout(l); localStorage.setItem(KEY, JSON.stringify(l)); };
  const upd = (id, f) => save(layout.map((x) => (x.id === id ? { ...x, ...f(x) } : x)));
  const drop = (target) => {
    const from = dragId.current; dragId.current = null;
    if (!from || from === target) return;
    const l = layout.filter((x) => x.id !== from);
    l.splice(l.findIndex((x) => x.id === target), 0, layout.find((x) => x.id === from));
    save(l);
  };
  const hidden = Object.keys(WIDGETS).filter((k) => !layout.some((x) => x.id === k));

  return (
    <div data-testid="dashboard" className="mw-fade-up flex h-[calc(100vh-90px)] flex-col gap-2">
      <div className="flex shrink-0 items-center gap-2">
        <h1 className="font-head text-xl font-bold tracking-tight text-white">GÖSTERGE PANELİ</h1>
        {edit && hidden.length > 0 && (
          <select data-testid="dash-add-widget" value="" onChange={(e) => e.target.value && save([...layout, { id: e.target.value, w: 1, h: 1 }])} className="h-8 rounded-md border border-emerald-700 bg-emerald-950/40 px-2 text-xs font-bold text-emerald-300">
            <option value="">+ KUTU EKLE</option>
            {hidden.map((k) => <option key={k} value={k}>{WIDGETS[k].t}</option>)}
          </select>
        )}
        <div className="ml-auto flex gap-2">
          {edit && <button data-testid="dash-reset" onClick={() => save(DEFAULT_LAYOUT)} className="flex h-8 items-center gap-1 rounded-md border border-slate-700 bg-slate-800 px-3 text-xs font-bold text-slate-300"><RotateCcw className="h-3.5 w-3.5" /> VARSAYILAN</button>}
          <button data-testid="dash-edit-toggle" onClick={() => setEdit((e) => !e)} className={`flex h-8 items-center gap-1 rounded-md px-3 text-xs font-bold ${edit ? "bg-emerald-600 text-white" : "border border-slate-700 bg-slate-800 text-slate-200"}`}>
            {edit ? <><Check className="h-3.5 w-3.5" /> BİTTİ</> : <><LayoutGrid className="h-3.5 w-3.5" /> YERLEŞİMİ DÜZENLE</>}
          </button>
        </div>
      </div>
      {edit && <div className="shrink-0 text-[11px] text-slate-400">KUTULARI SÜRÜKLEYİP YERİNİ DEĞİŞTİRİN · <ArrowLeftRight className="inline h-3 w-3" /> GENİŞLİK · <ArrowUpDown className="inline h-3 w-3" /> YÜKSEKLİK · <X className="inline h-3 w-3" /> KALDIR</div>}
      <div className="grid min-h-0 flex-1 grid-cols-2 gap-2 lg:grid-cols-4" style={{ gridAutoRows: "minmax(0, 1fr)", gridAutoFlow: "dense" }}>
        {layout.map((x) => {
          const W = WIDGETS[x.id];
          return (
            <div key={x.id} data-testid={`dash-widget-${x.id}`} draggable={edit}
              onDragStart={() => { dragId.current = x.id; }} onDragOver={(e) => edit && e.preventDefault()} onDrop={() => drop(x.id)}
              style={{ gridColumn: `span ${x.w}`, gridRow: `span ${x.h}` }}
              className={`flex min-h-0 flex-col overflow-hidden rounded-xl border bg-slate-900 p-3 ${edit ? "cursor-move border-dashed border-emerald-600/60" : "border-slate-800"}`}>
              <div className="mb-1 flex shrink-0 items-center gap-1">
                <span className="truncate text-[11px] font-semibold uppercase tracking-wider text-slate-500">{W.t}</span>
                {edit && (
                  <div className="ml-auto flex gap-0.5">
                    <button data-testid={`dash-w-${x.id}`} title="GENİŞLİK" onClick={() => upd(x.id, (o) => ({ w: o.w >= 4 ? 1 : o.w + 1 }))} className="rounded bg-slate-800 px-1 text-[10px] font-bold text-slate-200"><ArrowLeftRight className="inline h-3 w-3" />{x.w}</button>
                    <button data-testid={`dash-h-${x.id}`} title="YÜKSEKLİK" onClick={() => upd(x.id, (o) => ({ h: o.h >= 3 ? 1 : o.h + 1 }))} className="rounded bg-slate-800 px-1 text-[10px] font-bold text-slate-200"><ArrowUpDown className="inline h-3 w-3" />{x.h}</button>
                    <button data-testid={`dash-remove-${x.id}`} title="KALDIR" onClick={() => save(layout.filter((y) => y.id !== x.id))} className="rounded bg-rose-900/60 px-1 text-rose-200"><X className="h-3 w-3" /></button>
                  </div>
                )}
              </div>
              <div className="min-h-0 flex-1 overflow-auto">{W.r(data)}</div>
            </div>
          );
        })}
        {edit && hidden.length > 0 && layout.length === 0 && <div className="flex items-center justify-center rounded-xl border border-dashed border-slate-700 text-xs text-slate-500"><Plus className="mr-1 h-4 w-4" /> YUKARIDAN KUTU EKLEYİN</div>}
      </div>
    </div>
  );
}
